import { Typography, useTheme } from "@mui/material";
import { useAppSelector } from "src/store/store";
import { selectTotalConsumption } from "src/store/slices/planMixesTableEditSlice";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { PlanId } from "../boundary/PlanId";
import { Period } from "hooks/periodIndex";

interface Props {
  planId: PlanId;
  period: Period;
  materialName: string;
  inventoryAmount: number;
  massScaleFactor: number;
}

export const TotalConsumptionCell = ({
  planId,
  period,
  materialName,
  inventoryAmount,
  massScaleFactor,
}: Props) => {
  const theme = useTheme();

  const total = useAppSelector((state) =>
    selectTotalConsumption(state, planId, period, materialName)
  );
  const { format } = useNumberSerialiser({ decimalPlaces: 0 });

  const backgroundColor =
    total > inventoryAmount
      ? theme.palette.error.main
      : theme.palette.common.white;
  const color =
    total > inventoryAmount
      ? theme.palette.common.white
      : theme.palette.common.black;

  return (
    <Typography
      variant="body1Mono"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor,
        color,
      }}
    >
      {format(total * massScaleFactor)}
    </Typography>
  );
};
